// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// this should work
import Vue from "vue";
import App from "./App";
import Vuex from "vuex";
import { store } from "./store";
import { notification } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import "./styles/main.scss";
import VueFloatLabel from "vue-float-label";
import VueSVGIcon from "vue-svgicon";
import "./assets/icons";
import VueCookies from "vue-cookies";
import VueToast from "vue-toast-notification";
import VueEasyLightbox from "vue-easy-lightbox";
// Import one of available themes
import "vue-toast-notification/dist/theme-default.css";
import Cleave from "vue-cleave-component";
import PrettyCheckbox from "pretty-checkbox-vue";
import VuePageTitle from "vue-page-title";
import "../plugins/filters";
import VCalendar from "v-calendar";
import JsonCSV from "vue-json-csv";
import SimpleVueValidation from "simple-vue-validator";
import "./components/resuables";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Vuelidate from "vuelidate";

Vue.use(VuePageTitle, { router });
Vue.use(VueToast, {
  // One of the options
  position: "top-right"
});
Vue.use(PrettyCheckbox);
Vue.prototype.$notification = notification;
Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueEasyLightbox);
Vue.use(BootstrapVue);
Vue.use(VueFloatLabel);
Vue.use(VueSVGIcon);
Vue.use(VueCookies);
Vue.use(Cleave);
Vue.use(VCalendar, {
  componentPrefix: "v"
});
Vue.component("downloadCsv", JsonCSV);
Vue.use(SimpleVueValidation);
Vue.prototype.$Validator = SimpleVueValidation.Validator;
Vue.use(VueTimepicker);
Vue.use(Vuelidate);

/* eslint-disable no-new */
new Vue({
  store,
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js